import { ISessionService } from "../domain/interfaces/ISessionService"

const GetSessionStatusUseCase = async (service: ISessionService, localId: string): Promise<boolean> => {
    const response = await service.isOpened(localId)
    return (response.isOpened);
}
export default GetSessionStatusUseCase